<div class="profile-selection-container">
  <app-info-box [title]="('steps.profileSelection.title' | translate) + typeAppointment.toLowerCase() + '?'" [description]="'steps.profileSelection.description' | translate">
  </app-info-box>
  <div class="selectors-container">
    @if (profiles?.relatedProfiles?.length >= 1) {
      <nz-radio-group role="radiogroup" aria-label="Seleziona il profilo per il care manager" [formControl]="profileSelected">
        <div class="selector">
          <label nz-radio [nzValue]="profiles" aria-label="{{ profiles?.['fullName'] }}">{{ profiles?.['fullName'] }}</label>
        </div>
        @for (profile of profiles.relatedProfiles; track profile) {
          <div class="selector">
            <label nz-radio [nzValue]="profile" aria-label="{{ profile?.['fullName'] }}">{{ profile?.['fullName'] }}</label>
          </div>
        }
        <div class="selector last-element" role="button" tabindex="0" (click)="createProfile()" (keydown.enter)="createProfile()" (keydown.space)="createProfile(); $event.preventDefault()">
          <img src="/public/assets/images/plus-circle.svg" aria-hidden="true" />
          <p>{{ 'steps.profileSelection.addPerson' | translate }}</p>
        </div>
      </nz-radio-group>
    }
  </div>
  @if (profileSelected.value || profiles?.relatedProfiles?.length === 0) {
    <div class="data-container">
      <h3>{{ 'steps.profileSelection.dataProfile' | translate }}</h3>
      <nz-divider></nz-divider>
      <div class="info-container">
        <div>
          <p class="title">
            {{ 'steps.profileSelection.profile' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.fullName ? profileSelected.value.fullName : '-' }}</p>
        </div>
        <div>
          <p class="title">
            {{ 'steps.profileSelection.telephone' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.phone ? profileSelected.value.phone : '-' }}</p>
        </div>
        <div>
          <p class="title">
            {{ 'steps.profileSelection.email' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.email ? profileSelected.value.email : '-' }}</p>
        </div>
      </div>
      <div class="subtitle-container">
        @if (profileSelected.value.fullName && profileSelected.value.phone && profileSelected.value.email) {
          <span nz-icon nzType="info-circle" nzTheme="fill"></span>
          <p class="inner-container" innerHTML="{{ 'steps.profileSelection.dataVerify' | translate }}"></p>
          <a role="button" tabindex="0" (click)="switchProfile(profileSelected)" (keydown.enter)="switchProfile(profileSelected)" (keydown.space)="switchProfile(profileSelected); $event.preventDefault()">{{ 'steps.profileSelection.goToProfile' | translate }}</a>
        } @else {
          <span nz-icon nzType="close-circle" nzTheme="fill"></span>
          <p class="inner-container" innerHTML="{{ 'steps.profileSelection.dataVerifyError' | translate }}"></p>
          <a role="button" tabindex="0" (click)="switchProfile(profileSelected)" (keydown.enter)="switchProfile(profileSelected)" (keydown.space)="switchProfile(profileSelected); $event.preventDefault()">{{ 'steps.profileSelection.goToProfile' | translate }}</a>
        }
      </div>
    </div>
  }
</div>
